module.exports = __webpack_public_path__ + "static/hospitality-7d7e5728c67d819169cd872172e0a4ab.png";